import PropTypes from "prop-types";

import { combineClassNames } from "../../utils/appUtils";

import WPTertiaryButton from "../WPTertiaryButton";
import { WPTypography } from "../WPTypography";

import "./WPEmptyStates.scss";
const WPEmptyStates = ({
  description,
  titleMsg,
  className,
  icon: Icon,
  buttonText,
  onButtonClick,
  buttonIcon,
  buttonIconPlacement,
  buttonVariant,
  buttonSize,
  customIconClass,
}) => {
  return (
    <div className={combineClassNames("flex-center", className)}>
      <div className="flex-center empty-states-wrapper">
        {Icon && (
          <div
            className={combineClassNames(
              "flex-center empty-states-icon",
              customIconClass,
            )}
          >
            <Icon />
          </div>
        )}
        {(titleMsg || description) && (
          <div className="empty-states-copy">
            {titleMsg && (
              <WPTypography
                className="empty-states-title"
                asElement="h2"
                text={titleMsg}
              />
            )}
            {description && (
              <WPTypography
                className="empty-states-description"
                fontSize={14}
                text={description}
              />
            )}
          </div>
        )}
        {buttonText && (
          <WPTertiaryButton
            id="custom-button"
            onClick={onButtonClick}
            size={buttonSize}
            className="custom-button-margin"
            label={buttonText}
            icon={buttonIcon}
            iconPlacement={buttonIconPlacement}
            variant={buttonVariant}
          />
        )}
      </div>
    </div>
  );
};

WPEmptyStates.propTypes = {
  description: PropTypes.string,
  titleMsg: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.elementType,
  buttonText: PropTypes.string,
  onButtonClick: PropTypes.func,
  buttonIcon: PropTypes.node,
  buttonIconPlacement: PropTypes.oneOf(["before", "after"]),
  buttonVariant: PropTypes.oneOf(["text", "contained", "outlined"]),
  buttonSize: PropTypes.oneOf(["small", "medium", "large"]),
};

WPEmptyStates.defaultProps = {
  buttonIcon: null,
  buttonIconPlacement: "after",
  buttonVariant: "contained",
  buttonSize: "medium",
};

export default WPEmptyStates;
